import { FormRenderGroupTypes } from '../Shared/Components/FormRenderer/FormRenderGroup.types';
import { FormField, FormRenderTypes } from '../Shared/Components/FormRenderer';

export const contractTemplateFields: FormField[] = [
  {
    name: 'name',
    label: 'Nazwa szablonu',
    type: FormRenderTypes.input,
    value: '',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'contentHtml',
    label: 'Treść kontraktu',
    type: FormRenderTypes.wysiwyg,
    value: '',
    group: FormRenderGroupTypes.configuration,
    placeholder: 'Wprowadź treść szablonu kontraktu',
    sx: { minHeight: 500, width: '100%' },
  },
];
